module.exports = __webpack_public_path__ + "img/what_tip.c0adb7dd.png";